import { Show } from "solid-js";

import { isMobile } from "@/lib/isMobile";
import H5HomePage from "@/pages/h5/index.tsx";
import PCHomePage from "@/pages/pc/index.tsx";

export default function Index() {
  return (
    <Show when={isMobile()} fallback={<PCHomePage />} keyed>
      <H5HomePage />
    </Show>
  );
}
